// SuggestionPanel state — all transient. The panel holds a draft the person is typing,
// the photos they picked, and the inline auth they are stepping through; none of it is
// persisted (a File can't be, and a half-typed suggestion is not something to resurrect
// days later on a shared phone).
//
// `phase` is the visibility mechanism, as on the Rankometer / AccountPanel: one panel
// shows at a time, chosen by matching its configured phase.
//
//   contribution → identity → (verify | password → forgot) → sent
//
// A logged-out submitter is offered OTP/password auth on Continue from identity; every
// auth panel also carries a Skip that submits anonymously (the Rankometer's shape). A
// signed-in submitter goes identity → submit directly.
//
// `focus` is NOT a phase. Edit and Add Photos are ONE contribution form with two emphases
// — the title, the hint and the field order change, the model and the endpoint do not —
// so it is a modifier on the contribution panel, not a second panel to keep in step.
export default {
  open: false,           // the panel is revealed (a trigger button was pressed)
  phase: "contribution", // contribution | identity | verify | password | forgot | sent
  focus: "EDIT",         // EDIT | PHOTO — which button opened it

  // Contribution.
  files: [],             // the chosen photos, already transcoded to JPEG
  busy: false,           // the multipart submit is in flight
  progress: 0,           // 0-100, from xhr.upload
  status: null,          // { tone, text } | null — contribution/submit status

  // Identity / inline auth (mirrors the AccountPanel's auth state).
  person: null,          // { id, email, name } | null — the signed-in submitter, for the identity row
  authEmail: null,       // the address a code was sent to / a password is being entered for
  authBusy: false,       // an auth request is in flight
  authStatus: null,      // { code, tone, text } | null — auth-panel status
};
